import { AxiosGet } from "../AxiosWrapper";
import { DOCUMENTSTORE_SERVICE_URL } from "../../constants/ServiceUrls";

export const inventoryTotals = () => {
  return AxiosGet(
    `${DOCUMENTSTORE_SERVICE_URL}api/DashboardWidgetReports/InventoryTotals`
  );
};

export const physicalRecordsBreakdown = () => {
  return AxiosGet(
    `${DOCUMENTSTORE_SERVICE_URL}api/DashboardWidgetReports/PhysicalRecordsBreakdown`
  );
};
export const itemTypeByStatus = () => {
  return AxiosGet(
    `${DOCUMENTSTORE_SERVICE_URL}api/DashboardWidgetReports/ItemTypeByStatus`
  );
};

export const physicalRecordsDestructionOverview = () => {
  return AxiosGet(
    `${DOCUMENTSTORE_SERVICE_URL}api/DashboardWidgetReports/PhysicalRecordsDestructionOverview`
  );
};

export const physicalRecordsPendingDestructionOverview = () => {
  return AxiosGet(
    `${DOCUMENTSTORE_SERVICE_URL}api/DashboardWidgetReports/PhysicalRecordsPendingDestructionOverview`
  );
};

export const physicalWorkOrderOverviewByType = () => {
  return AxiosGet(
    `${DOCUMENTSTORE_SERVICE_URL}api/DashboardWidgetReports/PhysicalWorkOrderOverviewByType`
  );
};

export const workOrderSubmissionsForCurrentMonth = () => {
  return AxiosGet(
    `${DOCUMENTSTORE_SERVICE_URL}api/DashboardWidgetReports/WorkOrderSubmissionsForCurrentMonth`
  );
};

export const digitalStorageUsage = () => {
  return AxiosGet(
    `${DOCUMENTSTORE_SERVICE_URL}api/DashboardWidgetReports/DigitalStorageUsage`
  );
};

export default {
  inventoryTotals,
  physicalRecordsBreakdown,
  itemTypeByStatus,
  physicalRecordsDestructionOverview,
  physicalRecordsPendingDestructionOverview,
  physicalWorkOrderOverviewByType,
  workOrderSubmissionsForCurrentMonth,
  digitalStorageUsage,
};
